export default __webpack_public_path__ + "06bbc0c712151b57c466c566106b177d.ttf";